// Detects whether a newer app build has been deployed than the one this tab is running,
// by comparing the hashed entry script in the live index.html with the loaded one.
const ENTRY_RE = /\/assets\/index-[\w-]+\.js/;
const MIN_INTERVAL = 60 * 1000;

let lastCheck = 0;

function currentEntry() {
  const script = document.querySelector('script[type="module"][src*="/assets/index-"]');
  return script?.getAttribute("src")?.match(ENTRY_RE)?.[0] || null;
}

export async function isNewBuildAvailable() {
  const loaded = currentEntry();
  if (!loaded || Date.now() - lastCheck < MIN_INTERVAL) return false;
  lastCheck = Date.now();
  try {
    // cache: "reload" also refreshes the HTTP cache, so the following full page load gets the new index.html
    const res = await fetch("/", { cache: "reload" });
    if (!res.ok) return false;
    const live = (await res.text()).match(ENTRY_RE)?.[0];
    return !!live && live !== loaded;
  } catch (e) {
    return false;
  }
}
